/**
 * Lo que un producto de a paquete tiene que decir junto al precio (VTA-01):
 * cuánto cuesta la pieza y cuántas piezas trae el paquete, que es lo mínimo
 * que se puede comprar. Sin esto, $13.161 por un clavo parece un error.
 * Con la venta suelta no dibuja nada.
 */
import type { UnidadMedida } from '@elcarpintero/compartido';

import { esPaquete, nombrePieza, precioPieza, textoPiezas } from '../../utilidades/paquete';
import { Icono } from '../comunes/Icono';

export interface DetallePaqueteProps {
  producto: { precio: number; unidadesPorPaquete: number; unidadMedida: UnidadMedida };
}

export function DetallePaquete({ producto }: DetallePaqueteProps) {
  if (!esPaquete(producto)) return null;

  return (
    <dl className="ficha-paquete">
      <div>
        <dt>Precio por {nombrePieza(producto)}</dt>
        <dd>{precioPieza(producto)}</dd>
      </div>
      <div>
        <dt>Compra mínima</dt>
        <dd>
          <Icono nombre="caja" />
          Paquete de {textoPiezas(producto, 1)}
        </dd>
      </div>
    </dl>
  );
}
